module.exports = __webpack_public_path__ + "icomoon.343cab6b79ac1812903b.svg";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/vendors/by_hands/font-icomoon/fonts/icomoon.svg?mkks98
// module id = ../../../../../src/assets/vendors/by_hands/font-icomoon/fonts/icomoon.svg?mkks98
// module chunks = styles